import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#FFDC2E',
  gradientStop2 = '#D08629',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '24.52 8.02'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M2.03028 2.40004C3.37028 0.0500385 12.3702 1.13011 17.6702 3.97011C21.3002 5.91011 22.2403 9.21008 21.1303 11.6901C19.5703 15.1901 14.9803 15.6101 10.4603 13.6801C6.59027 12.0301 0.200278 5.62004 2.03028 2.40004Z"
        fill={`url(#${randomGradientId1})`}
        stroke="#231F20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M47.0002 2.40004C45.6602 0.0500385 36.6602 1.13011 31.3602 3.97011C27.7302 5.91011 26.7902 9.21008 27.9002 11.6901C29.4602 15.1901 34.0502 15.6101 38.5702 13.6801C42.4402 12.0301 48.8302 5.62004 47.0002 2.40004Z"
        fill={`url(#${randomGradientId2})`}
        stroke="#231F20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.5103 8.34013C21.5103 8.34013 24.4602 7.01013 27.6002 8.34013"
        stroke="#231F20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="11.6437"
          y1="-1.86314"
          x2="11.6437"
          y2="14.8335"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1586" stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="37.3885"
          y1="-1.86314"
          x2="37.3885"
          y2="14.8335"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1586" stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
